module.exports = __webpack_public_path__ + "img/64.fcf6c23e.jpg";